"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsCheckOutWindow = exports.getIsCheckInWindow = void 0;
const moment_1 = __importDefault(require("moment"));
// Check ins only allowed within 12 hours before/after booking start time
const getIsCheckInWindow = (bookingStartTime) => {
    const now = (0, moment_1.default)();
    const shiftStartTime = (0, moment_1.default)(bookingStartTime);
    const startCheckInWindow = shiftStartTime.clone().subtract(12, "hours");
    const endCheckInWindow = shiftStartTime.clone().add(12, "hours");
    const isCheckInWindow = now.isAfter(startCheckInWindow) && now.isBefore(endCheckInWindow);
    return isCheckInWindow;
};
exports.getIsCheckInWindow = getIsCheckInWindow;
// Check out of a booking is only allowed in the 30 hours after booking check in
// 1 day plus a little extra to accomodate TTM sleep over shifts
const getIsCheckOutWindow = (bookingCheckInTime) => {
    if (!bookingCheckInTime) {
        return false;
    }
    const now = (0, moment_1.default)();
    const shiftCheckInTime = (0, moment_1.default)(bookingCheckInTime);
    const endCheckOutWindow = shiftCheckInTime.clone().add(30, "hours");
    const isCheckOutWindow = now.isAfter(shiftCheckInTime) && now.isBefore(endCheckOutWindow);
    return isCheckOutWindow;
};
exports.getIsCheckOutWindow = getIsCheckOutWindow;
